import React, { useState } from 'react';
import './FAQ.css'; // Style file
import UpIcon from './../../assets/icons/ui/fe_arrow-up.svg';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  data: FAQItem[];
  title?: string;
}

const FAQ: React.FC<FAQProps> = ({ data, title = "FAQ" }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const renderAnswer = (answer: string) => {
    const lines = answer.split("\n");
  
    return (
      <div className="faq-answer-content">
        {lines.map((line, idx) => {
          if (line.startsWith("§")) {
            // Section title: Keep bold, no bullet
            return (
              <p key={idx} className="faq-section-title">
                {line.replace("§", "").trim()}
              </p>
            );
          } else if (line.startsWith("-")) {
            // List Item: Remove the dash before rendering
            return (
              <li key={idx} className="faq-list-item">
                {line.replace("-", "").trim()} {/* Removes the "-" */}
              </li>
            );
          } else {
            // Normal paragraph answer (if no list)
            return (
              <p key={idx} className="faq-answer">
                {line.trim()}
              </p>
            );
          }
        })}
      </div>
    );
  };
  
  
  

  return (
    <div className="faq-container">
      <h2 className="faq-title">{title}</h2>
      <div className="faq-list">
        {data.length > 0 ? (
          data.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3 className="faq-question-title">{index + 1}. {item.question}</h3>
                <span className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}>
                  <img src={UpIcon} alt="Toggle icon" />
                </span>
              </div>
              {openIndex === index && <div className="faq-answer-content">{renderAnswer(item.answer)}</div>}
            </div>
          ))
        ) : (
          <p className="faq-empty">No FAQs available.</p>
        )}
      </div>
    </div>
  );
};

export default FAQ;
